import InventoryNav from './InventoryNav';

export default InventoryNav;
